<template>
    <div class='container inbox'>
       <div class='header'>
        <div class='title'>收件箱</div>
        <div class='search'>
            <el-input size='small' placeholder="搜索消息主题" v-model="content">
            <el-button slot="append" type="success" @click='getList(content)'>搜索</el-button>
            </el-input>
        </div>
       </div>
       <div class='section' v-loading='loading'>
           <div class='readbtn'>
                <el-button @click='markRead'>已读</el-button>
            </div>
           <div class='message_list_item head'>
            <span class='status'>
                <el-checkbox v-model="isChoosenAll" @change='changeChoosen'></el-checkbox>
            </span>
            <span class='theme'>消息主题</span>
            <span class='recipients'>发件人</span>
            <span class='delivery_date'>发送日期</span>
            <span class='accessory'>附件</span>
           </div>
          <div v-for='(item,index) in boxList' :key='index' class='message_list_item item' :class='{"islooked":item.isLook === 1}'>
            <span class='status'>
                <el-checkbox v-model="item.isChoosen"></el-checkbox>
            </span>
            <span class='theme cursor' @click='goDetail(item.messageID)' >{{item.title}}</span>
            <span class='recipients'>{{item.userName}}</span>
            <span class='delivery_date'>{{item.sendTime}}</span>
            <span class='accessory'><span v-if='item.attachment != 0' style='font-size:18px;' class='fa fa-paperclip'></span></span>
           </div>
       </div>
       <el-dialog
        title="接收对象详情"
        :visible.sync="isShowDetailList"
        width="40%"
        :close-on-click-modal='false'>
            <detail-list></detail-list>
        </el-dialog>
        <div class='foot'>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                @current-change='getChange'
                :page-size=10>
            </el-pagination>
        </div>
    </div>
</template>

<script>
import ajax from '@/com/ajax'
import config from '@/com/config'
import detailList from '../../components/notice/detailList'

export default {
  data () {
    return {
      boxList: [],
      dialogVisible: false,
      content: '',
      isShowDetailList: false,
      total: 0,
      currentPage: 1,
      isChoosenAll: false,
      loading: false
    }
  },
  props: {
    category: {
      type: String
    }
  },
  components: {
    detailList
  },
  watch: {
    category (val) {
      this.getList()
    }
  },
  methods: {
    getList (content) {
      var self = this
      let param = {}
      this.boxList = []
      // 1、搜索参数
      if (content !== undefined) {
        param.title = content
      }
      param.pageNum = this.currentPage
      param.pageSize = 10
      let type = ''
      switch (this.category) {
        case 'system':
          type = '/?type=SYS_NORMAL'
          break
      }
      this.loading = true
      ajax.post(config.khsHost + '/infoflow/message/hhs/inbox/list' + type, param).then(function (res) {
        // console.log(res)
        if (res && res.success) {
          let list = res.body.list
          for (let i in list) {
            let obj = {}
            self.$set(obj, 'title', list[i].title)
            self.$set(obj, 'userName', list[i].userName)
            self.$set(obj, 'sendTime', list[i].sendTime)
            self.$set(obj, 'attachment', list[i].attachment)
            self.$set(obj, 'status', list[i].status)
            self.$set(obj, 'isLook', list[i].isLook)
            self.$set(obj, 'messageID', list[i].messageID)
            self.$set(obj, 'isChoosen', false)
            self.$set(self.boxList, i, obj)
          }
          let page = res.body.page

          self.total = page.total
        }
        self.loading = false
      })
    },
    showDetailList (id) {
      this.isShowDetailList = true
    },
    goDetail (id) {
      this.$router.push({path: 'detail', query: {id: id, type: 'inbox'}})
    },
    changeChoosen () {
      for (let i in this.boxList) {
        this.boxList[i].isChoosen = this.isChoosenAll
      }
    },
    markRead () {
      let msgIDs = ''
      for (let i in this.boxList) {
        if (this.boxList[i].isChoosen) {
          msgIDs += this.boxList[i].messageID + ','
        }
      }
      let self = this
      if (msgIDs !== '') {
        ajax.post(`${config.khsHost}infoflow/message/inbox/${msgIDs}/markRead`).then(function (res) {
          self.isChoosenAll = false
          self.getList()
        })
      }
    },
    getChange (e) {
      this.currentPage = e
      this.getList()
    }
  },
  mounted () {
   // this.category = this.$route.params.category
   // console.log(this.category)
  },
  created () {
    this.getList()
  }
}
</script>

<style scoped>
.container.inbox{
    width:100%;
    height:900px;
    background-color: #ffffff;
    display: block;
    padding:0px;
}
.inbox .header{
    display: flex;
    justify-content: space-between;
}
.inbox .title{
    font-size:20px;
    padding-top:30px;
    padding-left:30px;
}
.inbox .search{
    padding-top:30px;
    padding-right:20px;
}
.inbox .section{
    margin-top:20px;
    width: 100%;
    height: 700px;
     overflow-y:scroll;
}
.inbox .section .readbtn{
    padding-left:30px;
    padding-bottom:30px;
}
.message_list_item{
    min-height:60px;
    font-weight: 900;
   align-items:center;
    display: flex;
}
.message_list_item.item.islooked{
   color:#ddd
}
.message_list_item.head{
    background-color: #F5F5F5
}
.message_list_item .theme{
    display: inline-block;
    overflow-x: hidden;
    width:30%;
}
.message_list_item .recipients{
    display: inline-block;
    width:25%;
}
.message_list_item .delivery_date{
    display: inline-block;
    width:25%;
}
.message_list_item .accessory{
    display: inline-block;
    width:15%;
}
.message_list_item .status{
    display: inline-block;
    width:150px;
    text-align: center;
}
.message_list_item.item{
    border-bottom:1px solid #F5F5F5
}
.inbox .foot{
    position: relative;
    top:10px;
    text-align: center;
}
.cursor{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/inbox.vue